const getSidebarOptions = state => state.common.sidebarOptions;
const getMessageNotification = state => state.common.messageNotification;
export default {
  getSidebarOptions,
  getMessageNotification,
};
